import * as TYPES from '../types';
import { REDUX_CONSTANT } from '../../constants';

const initialState = { isLoading: false };

export default function getStudentSummaryInformation(
    state = initialState,
    action
) {
    switch (action.type) {
        case REDUX_CONSTANT.GET_LIST_OF_LAWREADY_STUDENTS:
            let studentSummaryDataList =
                action.payload &&
                action.payload.items &&
                action.payload.items.length > 0
                    ? action.payload.items
                    : [];
            return {
                ...state,
                isLoading: false,
                studentSummaryDataList: studentSummaryDataList,
                recordCountForLawReadyHome: action.payload.recordCount,
                sortOrderForLawReadyHome: action.payload.sortOrder,
                pageSizeForLawReadyHome: action.payload.pageSize,
                pageNumberForLawReadyHomes: action.payload.pageNumber,
                searchForLawReadyHome: action.payload.searchText,
                sortFieldForLawReadyHome: action.payload.sortField,
                selectedProducts:
                    action.payload.products &&
                    appendCheckedStatusToSelectedProducts(
                        action.payload.products
                    ),
                currentVendorId: action.payload.vendorId,
                currentVendorName: action.payload.vendorName
            };
        case REDUX_CONSTANT.ADD_LAWREADY_SUBSCRIBER_DATA:
            return {
                ...state,
                addLawReadySubscriberData: action.payload
            };

        case REDUX_CONSTANT.LAWREADY_RESEND_INVITATION_DATA:
            return {
                ...state,
                lawReadyResendInviteData: action.payload,
                isLoading: true
            };
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                studentSummaryDataList:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_LIST_OF_LAWREADY_STUDENTS
                        ? []
                        : state.studentSummaryDataList,
                addLawReadySubscriberData:
                    action.payload.title ==
                    REDUX_CONSTANT.ADD_LAWREADY_SUBSCRIBER_DATA
                        ? action.payload.msg
                        : state.addLawReadySubscriberData,

                lawReadyResendInviteData:
                    action.payload.title ==
                    REDUX_CONSTANT.LAWREADY_RESEND_INVITATION_DATA
                        ? action.payload.msg
                        : state.lawReadyResendInviteData
            };
        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };
        case REDUX_CONSTANT.ISLOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        default:
            return state;
    }
}
function appendCheckedStatusToSelectedProducts(selectedProducts) {
    let products = [];
    selectedProducts &&
        selectedProducts.length > 0 &&
        selectedProducts.map((id) => {
            products.push({ productId: id, isChecked: true });
        });
    return products;
}
